module.exports = __webpack_public_path__ + "static/img/17041B_1_2_C_20220305_LC.5fd5c7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17041B_1_2_C_20220305_LC.png
// module id = j9LR
// module chunks = 0